import { Box } from "@mui/material";
import { useUrlParams } from "../Hooks/useUrlParams";
import Chipas from "./Chip/Chip";

export const FiltruChipai = () => {
    const { params, setParam } = useUrlParams();
    
    const handleRemoveChip = (group, value) => {
        const newValue = params[group].filter(item => item !== value);

        setParam(group, newValue.length ? newValue : undefined)
    }

    return (
        Object.keys(params).length ?
            <Box flex justifyContent="flex-start">
                <Chipas
                    className='tendencijosChip'
                    filtrai={params}
                    removeChip={handleRemoveChip}
                />
            </Box>
            : undefined
    )
}
